import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import Swiper, { Navigation, Pagination, Autoplay } from 'swiper';

let swipers = []; // Store active Swiper instances

export default function initSwiper() {
  // Destroy old Swiper instances
  swipers.forEach(swiper => swiper.destroy(true, true));
  swipers = [];

  // Initialize Tour Carousel
  const tourCarousel = document.querySelector(".tour-carousel");
  if (tourCarousel) {
    const swiperInstance = new Swiper(".tour-carousel", {
      modules: [Navigation, Pagination, Autoplay],
      loop: true,
      autoplay: {
        delay: 4000,
        disableOnInteraction: false,
      },
      slidesPerView: 'auto',
      spaceBetween: 16,
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },
      pagination: {
        el: ".swiper-pagination",
        clickable: true,
      },
      speed: 600,
    });
    swipers.push(swiperInstance);
  }

  // Initialize News Swiper
  const newsSwiper = document.querySelector(".news-swiper");
  if (newsSwiper) {
    const swiperInstance = new Swiper(".news-swiper", {
      modules: [Navigation, Pagination],
      slidesPerView: 1,
      spaceBetween: 20,
      pagination: {
        el: ".swiper-pagination",
        clickable: true,
      },
      navigation: {
        nextEl: ".swiper-abutton-next",
        prevEl: ".swiper-abutton-prev",
      },
      breakpoints: {
        768: { slidesPerView: 2 },
        1024: { slidesPerView: 2 },
        1280: { slidesPerView: 2, slidesPerGroup: 2 },
        1536: { slidesPerView: 2, slidesPerGroup: 2 },
      },
    });
    swipers.push(swiperInstance);
  }

  // Initialize Course Swiper
  const courseSwiper = document.querySelector(".course-swiper");
  if (courseSwiper) {
    const swiperInstance = new Swiper(".course-swiper", {
      modules: [Navigation, Pagination],
      slidesPerView: 2,
      spaceBetween: 20,
      pagination: {
        el: ".swiper-pagination",
        clickable: true,
      },
      navigation: {
        nextEl: ".course-swiper-abutton-next",
        prevEl: ".course-swiper-abutton-prev",
      },
      breakpoints: {
        768: { slidesPerView: 2 },
        1024: { slidesPerView: 3 },
        1280: { slidesPerView: 3, slidesPerGroup: 2 },
        1536: { slidesPerView: 3, slidesPerGroup: 2 },
      },
    });
    swipers.push(swiperInstance);
  }
}
